import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      <span>© {new Date().getFullYear()} IVSG LLC.</span>
      <span>CRM Portal</span>
    </footer>
  );
}

export default Footer;
